import React from 'react';
import { useTranslation } from 'react-i18next';
export const LeftSectionMessage = () => {
    const { t } = useTranslation('glossary');
    return (<div className="order-2 md:order-1">
            <h1 className="mt-3 text-3xl sm:text-4xl font-bold leading-tight text-primary">
                {t('sign_up.message.title')}
            </h1>

            <p className="mt-3 text-muted-foreground max-w-prose">{t('sign_up.message.description')}</p>

            <ul className="mt-6 space-y-2 text-sm text-muted-foreground">
                <li>• {t('sign_up.message.bullets.simpleLinks')}</li>
                <li>• {t('sign_up.message.bullets.compare')}</li>
                <li>• {t('sign_up.message.bullets.behavior')}</li>
            </ul>
        </div>);
};
